// V5 only adds new entities - nothing to migrate.
export const migrateToV5 = (state)=>state;

//# sourceMappingURL=v05.js.map